document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper('.images-sliders', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        const progressLine = document.querySelector(".progress");
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                on: {
                autoplayTimeLeft(s, time, progress) {
                    progressLine.style.setProperty("width", Math.abs(progress-1)*100+'%');
                }
            }
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper('.slider-slide', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                watchSlidesProgress: true,
                slidesPerView: 1,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                pagination: {
                    el: '.slider-pagination',
                    type: 'fraction',
                },
                breakpoints: {
                    780: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 2,
                    },
                },
            });
        });
    }

    let tapsTap = document.querySelectorAll('.taps-block');
    let tapsSlide = document.querySelectorAll('.taps-slider');
    if(tapsSlide){
        const tapsSlider = new Swiper('.taps-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            breakpoints: {
                600: {
                    autoHeight: false,
                },
            }
        });
        tapsTap.forEach(function(tB,tBc) {
            let tNav = tB.querySelectorAll('.taps-link');
            tNav.forEach(function(t_nav) {
                let navCount = t_nav.dataset.nav;
                t_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(tapsTap.length > 1){
                        tapsSlider[tBc].slideTo(navCount, 1000);
                    } else {
                        tapsSlider.slideTo(navCount, 1000);
                    }
                    tNav.forEach(function(t_nav) {
                        t_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(tapsTap.length > 1){
                    tapsSlider[tBc].on('slideChange', function () {
                        tNav.forEach(function(t_nav) {
                            let navC = t_nav.dataset.nav;
                            t_nav.classList.remove('active');
                            if(tapsSlider[tBc].realIndex == navC){
                                t_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    tapsSlider.on('slideChange', function () {
                        tNav.forEach(function(t_nav) {
                            let navC = t_nav.dataset.nav;
                            t_nav.classList.remove('active');
                            if(tapsSlider.realIndex == navC){
                                t_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let reviewsSlides = document.querySelectorAll('.reviews-slides');
    if(reviewsSlides){
        reviewsSlides.forEach((item)=> {
            new Swiper('.reviews-slides', {
                loop: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let sliderNtSlider = document.querySelectorAll('.slider-nt-slider');
    if(sliderNtSlider){
        sliderNtSlider.forEach((item)=> {
            new Swiper('.slider-nt-slider', {
                loop: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    },
                }
            });
        });
    }

    let overlapCopy = document.querySelectorAll('.overlap-copy');
    let overlapImgSlider = document.querySelectorAll('.overlap-img-slider');
    if(overlapImgSlider){
        const overlapSlider = new Swiper('.overlap-img-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        overlapCopy.forEach(function(oB,oBc) {
            let oNav = oB.querySelectorAll('.copy-items');
            oNav.forEach(function(o_nav) {
                let navOver = o_nav.dataset.nav;
                o_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(overlapCopy.length > 1){
                        overlapSlider[oBc].slideTo(navOver, 1000);
                    } else {
                        overlapSlider.slideTo(navOver, 1000);
                    }
                    oNav.forEach(function(o_nav) {
                        o_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                o_nav.addEventListener('mouseover', function(e){
                    if(overlapCopy.length > 1){
                        overlapSlider[oBc].slideTo(navOver, 1000);
                    } else {
                        overlapSlider.slideTo(navOver, 1000);
                    }
                    oNav.forEach(function(o_nav) {
                        o_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(overlapCopy.length > 1){
                    overlapSlider[oBc].on('slideChange', function () {
                        oNav.forEach(function(o_nav) {
                            let navO = o_nav.dataset.nav;
                            o_nav.classList.remove('active');
                            if(overlapSlider[oBc].realIndex == navO){
                                o_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    overlapSlider.on('slideChange', function () {
                        oNav.forEach(function(o_nav) {
                            let navO = o_nav.dataset.nav;
                            o_nav.classList.remove('active');
                            if(overlapSlider.realIndex == navO){
                                o_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let carouselSlider = document.querySelectorAll('.carousel-slider');
    if(carouselSlider){
        carouselSlider.forEach((item)=> {
            new Swiper('.carousel-slider', {
                slidesPerView: 1,
                spaceBetween: 10,
                rewind: true,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-car-next",
                    prevEl: ".sw-car-prev",
                },
                breakpoints: {
                    780: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 2,
                        autoHeight: false,
                    },
                }
            });
        });
    }

});